import React, { useEffect, useState } from 'react';
import { observer, inject } from 'mobx-react';
import { getChildInject, getTrans } from '@/utils/instantLoaded/tools';
import { Modal } from '@shopee/chatbot-ui';
import { ModalProps } from '@shopee/chatbot-ui/lib/components/Modal/Base';
import { ButtonAction, getButtonAction } from '@/utils/getButtonData';
import { updateDialogueInfo } from '@/utils/sessionUtils';
import { InitStoreType } from '@/types/store/init';
import { Delivery, INPUT_TYPE, TRACKING_MSG_TYPE, TRACKING_OPERATION, TRACKING_PAGE, TRACKING_SECTION, TRACKING_TARGET } from '@/utils/constants';
import { dispatchTrack } from '@/utils/tracking';
import { ChatbotUIBasicProps } from '@/types/common';

export type ExpediteDeliveryModalProps = {
  taskbotInfo: any;
  action: {
    action_type: ButtonAction;
    task_bot_action: any;
  };
  modalProps: {
    title: string;
    content: string;
    read_more: string;
    confirm_value: string;
    refuse_value: string;
  };
  article: {
    title: string;
    content: string;
  };
  orderShopInfo: {
    shop_id: number;
    order_id: number;
  };
} & {
  initStore: InitStoreType;
  dialogueId: string;
  threadNodeId: string;
  threadId: string;
  threadIdV2: string;
  roundId: string;
  cardPosition: number;
  kbIntentId: any;
} & ChatbotUIBasicProps;

const ExpediteDeliveryModal: React.FC<ExpediteDeliveryModalProps> = (props) => {
  const [active, setActive] = useState(true);

  const modalProps = {
    title: getTrans(Delivery.EXPEDITE_DELIVERY_TITLE),
    confirm_value: getTrans(Delivery.EXPEDITE_DELIVERY_CONFIRM),
    refuse_value: getTrans(Delivery.EXPEDITE_DELIVERY_CANCEL),
  };
  const trackingParams = {
    page: TRACKING_PAGE.MAIN_PAGE,
    operation: TRACKING_OPERATION.IMPRESSION,
    target: TRACKING_TARGET.expediteDelivery,
    section: TRACKING_SECTION.expediteDelivery,
  };
  const trackingData = {
    chat_session_id: props.isHistory ? props.historySessionId : props.sessionId || '',
    chat_dialogue_id: props.isHistory ? props.historyDialogueId : props.dialogueId,
    if_history: props.isHistory ? TRACKING_MSG_TYPE.HISTORY : TRACKING_MSG_TYPE.REAL_TIME,
    bot_id: props.taskbotInfo?.bot_id,
    intent_id: props.taskbotInfo?.intent_id,
  };

  useEffect(() => {
    dispatchTrack({ ...trackingParams, data: trackingData });
  }, []);

  const uiModalProps = {
    type: 'modal',
    active,
    title: modalProps?.title,
    onClose: () => setActive(false),
    contentContainerStyle: { width: 305 },
    footer: {
      layout: 'horizontal',
      buttons: [
        {
          text: modalProps?.refuse_value,
          style: { color: '#000' },
          onClick: () => {
            dispatchTrack({
              ...trackingParams,
              target: TRACKING_TARGET.expediteDeliveryButton,
              data: { ...trackingData, button_text: modalProps?.refuse_value },
            });
            setActive(false);
          },
        },
        {
          text: modalProps?.confirm_value,
          action: {
            showUserMessage: true,
            _actualText_: modalProps?.confirm_value,
            func: getButtonAction(ButtonAction.ExpediteDeliverySubmit),
            info: props,
            data: {
              dialogue_id: props.dialogueId,
              session_id: props.initStore.sessionId,
              thread_id: props.threadId,
              api_key: 'expedite_delivery',
              query_data: JSON.stringify(props?.orderShopInfo),
            },
            nextParams: {
              message_text: modalProps?.confirm_value,
              input_type: INPUT_TYPE.BUTTON,
              session_id: props.initStore.sessionId,
              dialogue_id: props.dialogueId,
              thread_node_id: props.threadNodeId,
              thread_id: props.threadId,
              thread_id_v2: props.threadIdV2,
              round_id: props.roundId,
              is_bypass: props?.action?.task_bot_action?.is_bypass || false,
              message_extra: {
                params: {
                  // cancel_reason_code: optionValue,
                  order_id: props?.orderShopInfo?.order_id,
                  shop_id: props?.orderShopInfo?.shop_id,
                  // refund_destination: props.refundDestination,
                },
                task_bot_action: {
                  ...(props?.action?.task_bot_action || {}),
                  task_bot_info: props.taskbotInfo,
                  // ...{ params: assignParams(props.action.task_bot_action.params, { cancel_reason_code: optionValue! }) },
                },
              },
            },
            callback: () => {
              // expediteDelivery点击一次后需要禁止再次点击
              updateDialogueInfo({ isExpediteDeliveryDisabled: true }, props.cardPosition);
            },
          },
          onClick: () => {
            dispatchTrack({
              ...trackingParams,
              target: TRACKING_TARGET.expediteDeliveryButton,
              data: { ...trackingData, button_text: modalProps?.confirm_value },
            });
            setActive(false);
          },
        },
      ],
    },
  };

  const contentList = (getTrans(Delivery.EXPEDITE_DELIVERY_CONTENT)).split(getTrans(Delivery.EXPEDITE_DELIVERY_CONFIRM));

  return (
    <>
      <Modal {...(uiModalProps as ModalProps)}>
        <div style={{ fontSize: '14px', color: 'rgba(0, 0, 0, 0.65)', marginBottom: '4px' }}>
          {contentList[0]}
          <span style={{ fontWeight: '500', color: 'rgba(0, 0, 0, 0.87)' }}>
            {getTrans(Delivery.EXPEDITE_DELIVERY_CONFIRM)}
          </span>
          {contentList[1]}
        </div>
      </Modal>
    </>
  );
};

export default inject(getChildInject('initStore'))(observer(ExpediteDeliveryModal));
